module.exports = __webpack_public_path__ + "static/media/manage-acess-first.c1355d4a.png";